import React from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { Row, Col, Card } from 'antd';

import ZonesView from './ZonesView';
import ZoneEdit from './ZoneEdit';
import UsersCard from './UsersCard';
import UsersList from './UsersList';
import UserEdit from './UserEdit';

import styles from './styles.module.scss';

export const UsersManagementRender = ({ addUser, goBack, match: { path } }) => (
  <div>
    <div className={styles.header}>
      <h1 className={styles.header__title}>
        Gestion des agents et des zones de triage
      </h1>
    </div>
    <Row gutter={24}>
      <Col md={16}>
        <Card title="Zones de triage">
          <ZonesView path={path} />
        </Card>
      </Col>
      <Col
        md={8}
      >
        <Switch>
          <Route
            path={`${path}/zone/:id`}
            exact
            component={({ match: { params: { id } } }) => (
              <ZoneEdit id={id} />
            )}
          />
          <Route
            path={`${path}/:id`}
            exact
            component={({ match: { params: { id } } }) => (
              <UsersCard
                id={id}
                actionLabel="Retour"
                action={goBack}
              >
                <UserEdit id={id} />
              </UsersCard>
            )}
          />
          <Route
            path=""
            exact
            component={() => (
              <UsersCard
                actionLabel="+ Ajouter"
                action={addUser}
              >
                <UsersList />
              </UsersCard>
            )}
          />
        </Switch>
      </Col>
    </Row>
  </div>
);

export default withRouter(UsersManagementRender);



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/render.js